import { css } from "styled-components"

export const ContentWrapperStyles = css``;
